import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next'
import i18n from 'cityads-v3/i18n';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';

import PopupArticle from 'cityads-v3/components/PopupArticle/PopupArticle';
import classNames from './CookiePolicy.scss';


@withRouter
@connect(
  state => ({
    checkingAuth: state.auth.checkingAuth,
    authChecked : state.auth.isAuthChecked,
  }),
)
@withTranslation(['main'], { i18n, wait: !!window })
export default class CookiePolicy extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    checkingAuth: PropTypes.bool,
    authChecked : PropTypes.bool,
  };

  state = {
    open: window ? window.localStorage.cookiePolicy !== '1' : true
  }

  close() {
    if (window) {
      window.localStorage.cookiePolicy = '1';
    }

    this.setState({
      open: false
    });
  }

  render() {
    const { t, checkingAuth, authChecked } = this.props;

    return this.state.open && !checkingAuth && authChecked && (
      <div
        className = {classNames.tooltip}
        onClick   = {() => this.close()}
      >
        <span
          className = {classNames.tooltipClose}
          onClick   = {() => this.close()}
          title     = {t('buttons.close')}
        ></span>

        <Trans t={t} i18nKey={'cookiePolicy'}>
          Welcome to CityAds.com website!
          This website uses cookies to facilitate your use of the site and allow us to see how the site is used.
          The cookies cannot identify you.
          By continuing to use the website you consent to the use of cookies.
          If you would like to use the website without some cookies or would like to know more about how we use cookies
          please refer to the <Link
            to="/main/cookiePolicy"
            onClick={(evt) => {
              evt.stopPropagation()
              this.setState({ open: false })
            }}
          >CityAds Cookie Policy</Link>
        </Trans>
      </div>
    );
  }
}

@withRouter
export class CookiePolicyPopup extends Component {
  render() {
    return (
      <PopupArticle
        title          = "CityAds Cookie Policy"
        open           = {true}
        onRequestClose = {() => {
          this.props.history.goBack();
        }}
      >
        <div>
          <p>
            CityAds Group companies, the companies behind the cityads.com website do not identify users of this website.
            Although the website uses cookies.
          </p>

          <p>
            Cookies are files containing a small amount of text data that are saved at the user devices (computers).
            At a request from the system (web-server) they transfer information about the user’s behavior in the
            Internet (visiting specific web-sites and viewing specific pages at such web-sites).
            You may find more information on what is cookies and how they may be used on Internet, e.g.
            on <a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">www.aboutcookies.org</a>,
            and find legal background for this policy from the EU law perspective
            at <a
              href   = "https://eur-lex.europa.eu/legal-content/EN/ALL/?uri=CELEX:32009L0136"
              target = "_blank"
              rel    = "noopener noreferrer"
            >
              https://eur-lex.europa.eu/legal-content/EN/ALL/?uri=CELEX:32009L0136
            </a>.
          </p>

          <p>
            The cookies are used on cityads.com website initially to better choose on what language the site will be
            shown to you by default (although you are free to change the language via website interface), as well as
            for understanding what website pages were visited by you. The second purpose is to properly authenticate
            you in case you are intending to register or are registered on the website as advertiser of publisher.
            In case you delete cookies you will not be able to register or enter into registered personal account on
            the website. The third reason to use cookies, and these are cookies of third party partner of CityAds Group,
            is to receive information from what website you came to cityads.com website and whether you returned to it
            after the first visit.
          </p>

          <p>
            In case you do not want to use cookies you in most cases may delete some cookies in your computer,
            your browser probably lets you choose whether to accept browser cookies. And you may even be able
            to choose or limit the use of cookies and other similar technologies in mobile apps. For more information
            about how to manage your cookie settings, please follow the instructions provided by your browser which
            are usually located within the “Help,” “Tools,” or “Edit” settings. Please be informed that some website
            functionality may be unavailable in case you delete or disable cookies.
          </p>

          <p>
            If you have any questions about our use of cookies, please contact us.
          </p>
        </div>
      </PopupArticle>
    );
  }
}
